/* eslint-disable no-unused-vars, no-loop-func */
// ═══════════════════════════════════════════════════════════════
// ASPIRATING SMOKE DETECTION (ASD) CALCULATION ENGINE v3.0
// Cabinet/rack support, CSD conservative limits, crossed-zone,
// filter/adaptor logic, label logic, pipe addressability
// ═══════════════════════════════════════════════════════════════

var FT_TO_M = 0.3048;
export function toMeters(len, isMetric) { return isMetric ? parseFloat(len) || 0 : (parseFloat(len) || 0) * FT_TO_M; }

// ─── Detector catalog ───
// maxHoles/maxLinear = datasheet values; CSD has conservative overrides applied in code
var DETECTORS = [
  { id: "CSD-H10",  family: "CSD",     name: "CSD-H10",            desc: "Cabinet Smoke Detector - Smoke, Temp & Humidity",                   coverage: 100,  pipes: 1, maxLinear: 30,  maxHoles: 4,   suppressionCapable: false, hasTempHumidity: true,  hasCO: false, forCabinets: true,  networkCapable: true,  addressable: false },
  { id: "CSD-H11",  family: "CSD",     name: "CSD-H11",            desc: "Cabinet Smoke Detector - Smoke, Temp, Humidity & CO",               coverage: 100,  pipes: 1, maxLinear: 30,  maxHoles: 4,   suppressionCapable: false, hasTempHumidity: true,  hasCO: true,  forCabinets: true,  networkCapable: true,  addressable: false },
  { id: "HM1",      family: "Cupid",   name: "Cupid HM1",          desc: "Single Zone ASD - Temp & Humidity Sensors",                         coverage: 1600, pipes: 1, maxLinear: 105, maxHoles: 30,  suppressionCapable: false, hasTempHumidity: true,  hasCO: false, forCabinets: false, networkCapable: true,  addressable: false },
  { id: "HM1D",     family: "Cupid",   name: "Cupid HM1D",         desc: "Single Zone ASD - Temp, Humidity & CO Sensors",                     coverage: 1600, pipes: 1, maxLinear: 105, maxHoles: 30,  suppressionCapable: false, hasTempHumidity: true,  hasCO: true,  forCabinets: false, networkCapable: true,  addressable: false },
  { id: "HM2",      family: "Cupid",   name: "Cupid HM2",          desc: "Dual Zone ASD, Crossed Zone Release Control - Temp & Humidity",     coverage: 2000, pipes: 2, maxLinear: 105, maxHoles: 64,  suppressionCapable: true,  hasTempHumidity: true,  hasCO: false, forCabinets: false, networkCapable: true,  addressable: true  },
  { id: "HM2D",     family: "Cupid",   name: "Cupid HM2D",         desc: "Dual Zone ASD, Crossed Zone Release Control - Temp, Humidity & CO", coverage: 2000, pipes: 2, maxLinear: 105, maxHoles: 64,  suppressionCapable: true,  hasTempHumidity: true,  hasCO: true,  forCabinets: false, networkCapable: true,  addressable: true  },
  { id: "Q300r",    family: "Quartas", name: "Quartas-300r",       desc: "Single Pipe ASD, Relay Only",                                       coverage: 1200, pipes: 1, maxLinear: 75,  maxHoles: 32,  suppressionCapable: false, hasTempHumidity: false, hasCO: false, forCabinets: false, networkCapable: false, addressable: false },
  { id: "Q300s",    family: "Quartas", name: "Quartas-300s",       desc: "Single Pipe ASD, Network",                                          coverage: 1200, pipes: 1, maxLinear: 75,  maxHoles: 32,  suppressionCapable: false, hasTempHumidity: false, hasCO: false, forCabinets: false, networkCapable: true,  addressable: false },
  { id: "Q500r",    family: "Quartas", name: "Quartas-500r",       desc: "Single Pipe ASD, Relay Only",                                       coverage: 1860, pipes: 1, maxLinear: 100, maxHoles: 60,  suppressionCapable: false, hasTempHumidity: false, hasCO: false, forCabinets: false, networkCapable: false, addressable: false },
  { id: "Q500s",    family: "Quartas", name: "Quartas-500s",       desc: "Single Pipe ASD, Network",                                          coverage: 1860, pipes: 1, maxLinear: 100, maxHoles: 60,  suppressionCapable: false, hasTempHumidity: false, hasCO: false, forCabinets: false, networkCapable: true,  addressable: false },
  { id: "Q2000-1A", family: "Quartas", name: "Quartas-2000s (1A)", desc: "4-Pipe Single Zone ASD, Network",                                   coverage: 5700, pipes: 4, maxLinear: 100, maxHoles: 100, suppressionCapable: false, hasTempHumidity: false, hasCO: false, forCabinets: false, networkCapable: true,  addressable: false },
  { id: "Q2000-4A", family: "Quartas", name: "Quartas-2000s (4A)", desc: "4-Pipe Addressable Scanning ASD, Network",                          coverage: 5700, pipes: 4, maxLinear: 100, maxHoles: 100, suppressionCapable: false, hasTempHumidity: false, hasCO: false, forCabinets: false, networkCapable: true,  addressable: true  },
];

// CSD conservative limits for non-cabinet use
var CSD_CONSERVATIVE = { maxHoles: 3, maxLinear: 14, coverage: 27 };

var STANDARDS = {
  "NFPA 72": { spacingM: 7, iterativeSpacing: true, transportTimeS: 120, maxHeightM: 9.1 },
  "NFPA 76": { spacingM: 4, iterativeSpacing: false, transportTimeS: 60, maxHeightM: 9.1 },
  "EN54-A":  { spacingM: 4, iterativeSpacing: false, transportTimeS: 60, maxHeightM: 9.1 },
  "EN54-B":  { spacingM: 6, iterativeSpacing: false, transportTimeS: 90, maxHeightM: 9.1 },
  "EN54-C":  { spacingM: 8, iterativeSpacing: false, transportTimeS: 120, maxHeightM: 9.1 },
};

function standardKey(ds) {
  if (!ds) return "NFPA 72";
  if (ds.indexOf("NFPA 72") >= 0) return "NFPA 72";
  if (ds.indexOf("NFPA 76") >= 0) return "NFPA 76";
  if (ds.indexOf("Class A") >= 0) return "EN54-A";
  if (ds.indexOf("Class B") >= 0) return "EN54-B";
  if (ds.indexOf("Class C") >= 0) return "EN54-C";
  return "NFPA 72";
}

var OBJECTIVE_PREFS = {
  "Early Warning Detection":                            { families: ["CSD", "Cupid", "Quartas"] },
  "Early Warning & Crossed Zone Suppression Release":   { families: ["Cupid"], requireSuppression: true },
  "General Smoke Detection":                            { families: ["Quartas"] },
  "Complement to Passive Detection":                    { families: ["Quartas"] },
};

function needsFilter(env) { return ["Dusty", "Industrial / dirty", "Corrosive"].indexOf(env) >= 0; }
function isCriticalArea(at) { return ["Data Center", "Telecom Room", "Electrical Room"].indexOf(at) >= 0; }
function isCabinetZone(zt) { return zt === "Cabinet" || zt === "CPU Rack"; }
function calcHoles(areaM2, spacingM) { return Math.max(1, Math.ceil(areaM2 / (spacingM * spacingM))); }

function effectiveMaxSamplingPoints(detector, crossedZone, isCabinet) {
  // CSD conservative for non-cabinet
  if (detector.family === "CSD" && !isCabinet) return CSD_CONSERVATIVE.maxHoles;
  // HM2 crossed-zone: each sampling point uses 2 holes
  if (crossedZone && detector.suppressionCapable && detector.pipes === 2) return Math.floor(detector.maxHoles / 2);
  return detector.maxHoles;
}

// ─── Viable detector filter (used for override dropdown too) ───
export function getViableDetectors(config) {
  var prefs = OBJECTIVE_PREFS[config.detectionObjective] || OBJECTIVE_PREFS["Early Warning Detection"];
  var wantCO = config.coDetection === "Yes";
  var wantTH = config.tempHumiditySensors === "Yes";
  var wantNetwork = config.networkRequired === "Yes";
  var wantAddr = config.pipeAddressability === "Yes";
  var hasSuppression = config.hasSuppression === "Yes";
  var critical = isCriticalArea(config.areaType);

  return DETECTORS.filter(function(d) {
    if (wantTH && !d.hasTempHumidity) return false;
    if (wantCO && !d.hasCO) return false;
    if (wantNetwork && d.family === "Quartas" && !d.networkCapable) return false;
    if (wantAddr && d.pipes > 1 && !d.addressable) return false;
    if (prefs.requireSuppression && !d.suppressionCapable) return false;
    if (hasSuppression && critical && !d.suppressionCapable && d.family !== "CSD") return false;
    return true;
  });
}

// ─── Select detector for a zone ───
function selectDetector(totalSamplingPoints, totalAreaM2, longestDimM, crossedZone, isCabinet, config) {
  var prefs = OBJECTIVE_PREFS[config.detectionObjective] || OBJECTIVE_PREFS["Early Warning Detection"];
  var wantCO = config.coDetection === "Yes";
  var wantTH = config.tempHumiditySensors === "Yes";
  var wantNetwork = config.networkRequired === "Yes";
  var wantAddr = config.pipeAddressability === "Yes";
  var hasSuppression = config.hasSuppression === "Yes";
  var critical = isCriticalArea(config.areaType);

  var fam = prefs.families.slice();
  if (wantTH) { fam = fam.filter(function(f) { return f === "CSD" || f === "Cupid"; }); if (fam.length === 0) fam = ["CSD", "Cupid"]; }
  if (hasSuppression && critical) { if (fam.indexOf("Cupid") < 0) fam.push("Cupid"); }
  if (isCabinet) { fam = ["CSD"]; }

  var candidates = DETECTORS.filter(function(d) {
    if (isCabinet && !d.forCabinets) return false;
    if (!isCabinet && d.forCabinets && fam.length > 1) return false;
    if (prefs.requireSuppression && !d.suppressionCapable) return false;
    if (hasSuppression && critical && !isCabinet && !d.suppressionCapable) return false;
    if (fam.indexOf(d.family) < 0) return false;
    if (wantCO && !d.hasCO) return false;
    if (!wantCO && d.hasCO) return false;
    if (wantNetwork && d.family === "Quartas" && !d.networkCapable) return false;
    if (wantAddr && d.pipes > 1 && !d.addressable) return false;
    // Max pipe length check (CSD conservative for non-cabinet)
    if (!isCabinet) {
      var ml = (d.family === "CSD") ? CSD_CONSERVATIVE.maxLinear : d.maxLinear;
      if (longestDimM > 0 && longestDimM > ml * d.pipes) return false;
    }
    return true;
  });

  // Fallback: relax CO
  if (candidates.length === 0) {
    candidates = DETECTORS.filter(function(d) {
      if (isCabinet && !d.forCabinets) return false;
      if (!isCabinet && d.forCabinets) return false;
      if (fam.indexOf(d.family) < 0) return false;
      if (wantNetwork && d.family === "Quartas" && !d.networkCapable) return false;
      return true;
    });
  }
  if (candidates.length === 0) return { detector: DETECTORS.find(function(d) { return d.id === "Q500s"; }), qty: 1 };

  var best = null, bestQty = Infinity, bestScore = Infinity;
  for (var i = 0; i < candidates.length; i++) {
    var d = candidates[i];
    var maxPts = effectiveMaxSamplingPoints(d, crossedZone, isCabinet);
    var cov = (d.family === "CSD" && !isCabinet) ? CSD_CONSERVATIVE.coverage : d.coverage;
    var qtyByArea = Math.max(1, Math.ceil(totalAreaM2 / cov));
    var qtyByHoles = Math.max(1, Math.ceil(totalSamplingPoints / maxPts));
    var qty = Math.max(qtyByArea, qtyByHoles);
    var score = qty * 10000 + cov;
    if (score < bestScore) { bestScore = score; bestQty = qty; best = d; }
  }
  return { detector: best || candidates[0], qty: bestQty || 1 };
}

// ─── Calculate zone BOM ───
export function calculateZoneBOM(zone, config, isMetric) {
  var L = toMeters(zone.mainL, isMetric), W = toMeters(zone.mainW, isMetric), H = toMeters(zone.mainH, isMetric);
  if (L <= 0 || W <= 0) return null;

  var mainArea = L * W;
  var longestDim = Math.max(L, W);
  var cabinet = isCabinetZone(zone.zoneType);
  var critical = isCriticalArea(config.areaType);
  var stdKey = standardKey(config.designStandard);
  var std = STANDARDS[stdKey];
  var crossedZone = config.hasSuppression === "Yes" && critical && !cabinet;

  var spacingM = std.spacingM;
  var mainHoles = cabinet ? 1 : calcHoles(mainArea, spacingM);

  // Sub-zones (only for Main Area in critical spaces)
  var floorArea = 0, floorHoles = 0, ceilArea = 0, ceilHoles = 0;
  if (!cabinet && critical && zone.zoneType === "Main Area") {
    var fL = toMeters(zone.floorL, isMetric), fW = toMeters(zone.floorW, isMetric);
    if (fL > 0 && fW > 0) { floorArea = fL * fW; floorHoles = calcHoles(floorArea, spacingM); }
    var cL = toMeters(zone.ceilingL, isMetric), cW = toMeters(zone.ceilingW, isMetric);
    if (cL > 0 && cW > 0) { ceilArea = cL * cW; ceilHoles = calcHoles(ceilArea, spacingM); }
  }

  var totalSamplingPoints = mainHoles + floorHoles + ceilHoles;
  var totalCoverageArea = cabinet ? mainArea : (mainArea + floorArea + ceilArea);

  // NFPA 72 iterative spacing
  if (std.iterativeSpacing && !cabinet) {
    var spacings = [7, 8, 9];
    for (var si = 0; si < spacings.length; si++) {
      var tM = calcHoles(mainArea, spacings[si]);
      var tF = floorArea > 0 ? calcHoles(floorArea, spacings[si]) : 0;
      var tC = ceilArea > 0 ? calcHoles(ceilArea, spacings[si]) : 0;
      var tT = tM + tF + tC;
      var testSel = selectDetector(tT, totalCoverageArea, longestDim, crossedZone, false, config);
      if (testSel.qty <= 1 || si === spacings.length - 1) {
        spacingM = spacings[si]; mainHoles = tM; floorHoles = tF; ceilHoles = tC; totalSamplingPoints = tT;
        break;
      }
    }
  }

  // Select detector
  var sel;
  if (zone.detectorOverride) {
    var det = DETECTORS.find(function(d) { return d.id === zone.detectorOverride; });
    if (det) {
      var mp = effectiveMaxSamplingPoints(det, crossedZone, cabinet);
      var cv = (det.family === "CSD" && !cabinet) ? CSD_CONSERVATIVE.coverage : det.coverage;
      sel = { detector: det, qty: Math.max(1, Math.ceil(totalCoverageArea / cv), Math.ceil(totalSamplingPoints / mp)) };
    }
  }
  if (!sel) sel = selectDetector(totalSamplingPoints, totalCoverageArea, longestDim, crossedZone, cabinet, config);

  var detector = sel.detector;
  var dq = sel.qty;

  // Physical holes
  var physicalHoles = totalSamplingPoints;
  if (crossedZone && detector.suppressionCapable && detector.pipes === 2) physicalHoles = totalSamplingPoints * 2;

  // ─── BOM ───
  var items = [];
  var isDirty = needsFilter(config.environment);
  var uses8mm = cabinet && detector.family === "CSD";

  // 1. Detector
  items.push({ pn: detector.id, desc: detector.desc, qty: dq });

  // 2. Filter (dirty environments only)
  if (isDirty) {
    if (uses8mm) {
      items.push({ pn: "ASP-0102-08", desc: "External Filter (8mm capillary)", qty: dq });
    } else {
      var filterQty = dq * detector.pipes;
      items.push({ pn: "ASP-0102-25", desc: "External Filter (25mm OD)", qty: filterQty });
    }
  }

  // 3. Pipe adaptor ASP-0021 (25mm to 3/4")
  if (!uses8mm) {
    var adaptorQty = dq * detector.pipes; // base: 1 per pipe per detector
    if (isDirty) adaptorQty += dq * detector.pipes * 2; // +2 per filter
    items.push({ pn: "ASP-0021", desc: 'Pipe Adaptor 25mm to 3/4"', qty: adaptorQty });
  }

  // 4. Sampling points
  if (config.samplingPoints === "Yes" && !uses8mm) {
    items.push({ pn: "ASP-0005", desc: "Sampling Point Assembly (Bead - Washer - Nut)", qty: physicalHoles });
  }

  // 5. Cabinet-specific: 8mm tubing and brass sampling point
  if (uses8mm) {
    items.push({ pn: "ASP-0003", desc: "Brass Sampling Point (hole size: 2mm)", qty: 1 });
    // ASP-0012 tubing tracked at project level in aggregation
  }

  // 6. Remote Display
  if (config.remoteDisplay === "Yes" && (detector.family === "CSD" || detector.family === "Cupid")) {
    items.push({ pn: "RDU-PMC", desc: "Panel Mount Remote Display Unit", qty: dq });
  }

  // ─── Notes ───
  var notes = [];
  if (!cabinet && H > std.maxHeightM && H > 0) notes.push("Ceiling height (" + H.toFixed(1) + "m) exceeds " + std.maxHeightM + "m. Multi-level branched piping required.");
  var layers = [];
  if (floorHoles > 0) layers.push("raised floor (" + floorHoles + " pts)");
  if (ceilHoles > 0) layers.push("false ceiling (" + ceilHoles + " pts)");
  if (layers.length > 0) notes.push("Branched pipe covers: main room (" + mainHoles + " pts), " + layers.join(", ") + " \u2014 all from " + dq + " detector" + (dq > 1 ? "s" : "") + ".");
  if (crossedZone) notes.push("Crossed-zone: " + totalSamplingPoints + " sampling points \u00D7 2 pipes = " + physicalHoles + " physical holes.");
  if (critical && !cabinet && stdKey !== "NFPA 76" && stdKey !== "EN54-A") notes.push("Consider NFPA 76 or EN 54-20 Class A for critical area protection.");
  if (config.environment === "Cold (< 5\u00B0C / 40\u00B0F)" || config.environment === "High humidity") notes.push("Water trap must be incorporated into pipe network design.");
  if (config.highAirflow === "Yes") notes.push("High airflow: consider return-air sampling and airflow baffles.");
  if (config.hazardous === "Yes") notes.push("Hazardous/explosive environment: pipe network must comply with applicable explosion-proof standards.");

  // Sub-zone detail
  var subZones = [];
  if (floorHoles > 0) subZones.push({ name: "Raised Floor", area: Math.round(floorArea * 100) / 100, holes: floorHoles });
  if (ceilHoles > 0) subZones.push({ name: "False Ceiling", area: Math.round(ceilArea * 100) / 100, holes: ceilHoles });

  return {
    name: zone.name, zoneType: cabinet ? zone.zoneType : (zone.zoneType || "Main Area"),
    area: Math.round(mainArea * 100) / 100, height: Math.round(H * 100) / 100,
    detector: detector, detectorQty: dq,
    totalSamplingPoints: totalSamplingPoints, physicalHoles: physicalHoles,
    mainHoles: mainHoles, spacingM: spacingM, crossedZone: crossedZone,
    isCabinet: cabinet, uses8mm: uses8mm,
    subZones: subZones, notes: notes, items: items, standardKey: stdKey,
    mainL: zone.mainL, mainW: zone.mainW, mainH: zone.mainH,
  };
}

// ─── Multi-zone BOM ───
export function generateASDBOM(zones, config, isMetric) {
  var results = [], totalD = 0, totalSP = 0, totalPH = 0, agg = {};
  var has8mmZone = false, nonCabinetSP = 0;

  for (var i = 0; i < zones.length; i++) {
    var z = zones[i]; if (!z.mainL || !z.mainW) continue;
    var r = calculateZoneBOM(z, config, isMetric); if (!r) continue;
    results.push(r);
    totalD += r.detectorQty; totalSP += r.totalSamplingPoints; totalPH += r.physicalHoles;
    if (r.uses8mm) has8mmZone = true;
    if (!r.uses8mm) nonCabinetSP += r.totalSamplingPoints;
    for (var j = 0; j < r.items.length; j++) {
      var it = r.items[j];
      if (agg[it.pn]) agg[it.pn].qty += it.qty; else agg[it.pn] = { desc: it.desc, qty: it.qty };
    }
  }
  if (results.length === 0) return { error: "No valid zones. Enter dimensions for at least one zone." };

  // Network module
  if (totalD > 1 && config.networkRequired === "Yes") agg["NIM-1200-96"] = { desc: "Network Interface Module with HDMI", qty: 1 };

  // 8mm tubing roll (1 per project if any cabinet zones)
  if (has8mmZone && !agg["ASP-0012"]) agg["ASP-0012"] = { desc: "8mm Detection Tubing (100m Roll)", qty: 1 };

  // Labels (only for non-8mm zones)
  if (config.includeLabels === "Yes" && nonCabinetSP > 0) {
    if (config.samplingPoints === "Yes") {
      // ASP-0001: sheets of 6
      agg["ASP-0001"] = { desc: "Sampling Point Label (sheet of 6)", qty: Math.ceil(nonCabinetSP / 6) };
    } else {
      // ASP-0002: sheets of 10
      agg["ASP-0002"] = { desc: "Sampling Hole Label (sheet of 10)", qty: Math.ceil(nonCabinetSP / 10) };
    }
  }

  return {
    zoneResults: results, totalDetectors: totalD,
    totalSamplingPoints: totalSP, totalPhysicalHoles: totalPH,
    aggregatedBom: Object.entries(agg).map(function(e) { return { pn: e[0], desc: e[1].desc, qty: e[1].qty }; }),
  };
}

export var DETECTOR_LIST = DETECTORS;
export var DETECTION_OBJECTIVES = Object.keys(OBJECTIVE_PREFS);
export var ENVIRONMENTS = ["Clean", "Dusty", "Industrial / dirty", "Cold (< 5\u00B0C / 40\u00B0F)", "High humidity", "Corrosive"];
export var AREA_TYPES = ["Data Center", "Telecom Room", "Electrical Room", "Cabinet", "CPU Rack", "Warehouse", "Cold Room", "Airport Terminal", "Convention Center", "Archive / Museum", "Industrial / Factory", "Other"];
export var CEILING_TYPES = ["Flat", "Sloped", "Racked / Warehouse", "Exposed Structure"];
export var ZONE_TYPES_CRITICAL = ["Main Area", "Cabinet", "CPU Rack"];
export var ZONE_TYPES_GENERAL = ["Main Area", "False Ceiling", "Plenum Return", "Corridor / Hallway", "Storage / High Rack"];
export var DESIGN_STANDARDS = [
  "NFPA 72: General Fire Alarm Signaling",
  "NFPA 76: Telecom & IT Facility Protection",
  "EN 54-20 Class A: Very High Sensitivity (pre-smoke)",
  "EN 54-20 Class B: Enhanced Sensitivity (early detection)",
  "EN 54-20 Class C: Standard Sensitivity (equivalent to passive detection)",
];
export var CRITICAL_AREA_TYPES = ["Data Center", "Telecom Room", "Electrical Room"];
